import React from 'react';
import Panel from '../../../atoms/panels/Panel';
import Container from '../../blocks/Container';
import { Content, PrimaryContent } from '../../blocks/ColLayout';
import CanceledOffers from './CanceledOffers';
import SkeletonLoader from '../../../atoms/SkeletonLoader';
import ChangeEmail from '../../../screens/settings/change-email';
import PrivacyPreferences from '../PrivacyPreferences/PrivacyPreferences';

const Settings = props => {
  const { page, profile } = props;
  const { offer_counts } = profile;

  const renderSection = (page: string | null): any => {
    switch (page) {
      case 'rejected': {
        const offerType = 'rejected';
        const offerList = props.offers[offerType];
        const moreExists = Boolean(
          props.meta[`offer_${offerType}_current_page`] < props.meta[`offer_${offerType}_total_pages`]
        );

        if (offerList === undefined) {
          return null;
        }
        return <CanceledOffers {...props} offers={offerList} moreExists={moreExists} offerType={offerType} />;
      }
      case 'email-password':
        return <ChangeEmail />;
      case 'privacy-preferences':
        return <PrivacyPreferences />;
      case 'account-information':
        window.location.replace('/dashboard?showSettings=true&accountInfo=true');
        return <SkeletonLoader width="100%" />;
      default:
        window.location.replace('/dashboard');
        return <SkeletonLoader width="100%" />;
    }
  };

  if (!offer_counts && page !== 'privacy-preferences') return null;

  if (page === 'email-password' || page === 'privacy-preferences') {
    return renderSection(page);
  }

  return (
    <Container screenTop fullWidth>
      <Content style={{ background: 'transparent' }}>
        {/* @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389 */}
        <PrimaryContent fullWidth>
          <Panel
            withHeader
            customStyle={{
              padding: page === 'rejected' ? 0 : '',
              boxShadow: page === 'email-password' ? 'none' : '',
              border: page === 'email-password' ? 'none' : '',
              borderRadius: page === 'email-password' ? 0 : '',
              display: 'block',
              backgroundColor: '#FFF',
            }}
          >
            {renderSection(page)}
          </Panel>
        </PrimaryContent>
      </Content>
    </Container>
  );
};

export default Settings;
